export const customerInitialState = {
    isLoading: false,
    isGridListLoading: false,
    gridList: null,
    customerList: [],
    transactionTypes: null,
    transactionWorth: 0,
    transactionHistory: null
};